import { render } from "./examPaper.vue?vue&type=template&id=da3b6f18&scoped=true"
import script from "./examPaper.vue?vue&type=script&lang=js"
export * from "./examPaper.vue?vue&type=script&lang=js"

import "./examPaper.vue?vue&type=style&index=0&id=da3b6f18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da3b6f18"]])

export default __exports__